export enum CityValidation {
    Valid = 1,
    NotSpecified = 2,
    Invalid = 3,
}